<template>
  <div>
    <!-- чекбоксы -->
    <v-container>

      <v-card flat>
        <v-card-text>

          <v-container fluid>

            <h2 class="text-center">Фильтр вакансий</h2>

            <v-row
              class="mt-12"
              justify="space-between"
              no-gutters
            >
              <v-col
                cols="12"
                sm="3"
                md="3"
              >
                <v-checkbox
                  v-model="ex11"
                  key="Только актуальные"
                  label="Только актуальные"
                  color="red"
                  value="Актуальные вакансии"
                  @change="selectCategory"
                ></v-checkbox>

                <!-- <v-switch
                  v-model="ex11"
                  label="Только актуальные"
                  color="red"
                  value="Актуальные вакансии"
                  @change="selectCategory"
                ></v-switch> -->

              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
              >

                <v-switch
                  v-model="ex11"
                  key="Для мужчин"
                  label="Для мужчин"
                  color="blue"
                  value="Для мужчин"
                  :loading="warning"
                  @change="selectCategory"
                >
                </v-switch>

              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
              >

                <v-switch
                  v-model="ex11"
                  key="Для женщин"
                  label="Для женщин"
                  color="pink"
                  value="Для женщин"
                  :loading="warning"
                  @change="selectCategory"
                ></v-switch>

              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
              >

                <v-switch
                  v-model="ex11"
                  label="Для семейных пар"
                  color="orange "
                  value="Для семейных пар"
                  @change="selectCategory"
                  :loading="warning"
                ></v-switch>
              </v-col>
            </v-row>
            <!-- начало ряд 2 -->
            <v-row
              class="mt-12"
              justify="space-between"
              no-gutters
            >
              <v-col
                cols="12"
                sm="4"
                md="4"
              >

                <v-switch
                  v-model="ex11"
                  label="Только безвиз"
                  color="green"
                  value="Вакансии по безвизу"
                  @change="selectCategory"
                  :loading="warning"
                ></v-switch>

              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
              >

                <v-switch
                  v-model="ex11"
                  label="Только UA контракт"
                  color="deep-purple"
                  value="Вакансии по UA контракту"
                  @change="selectCategory"
                  :loading="warning"
                ></v-switch>

              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
              >

                <v-switch
                  v-model="ex11"
                  label="Только приезд в карантин"
                  color="amber"
                  value="Приезд из Украины (каранин)"
                  @change="selectCategory"
                  :loading="warning"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <h3 v-if="ex11.length"> Показаны ваканси: <h5>{{ex11.join(', ')}}</h5>
      </h3>
    </v-container>
    <!-- /чекбоксы -->
    <v-container>
      <v-text-field
        outlined
        label="
        Поиск (от 3 символов)"
        append-icon="mdi-magnify"
        @input="search_text"
        v-model="search.text"
      >
      </v-text-field>
      <p v-if="GET_EMPTY_SEARCH">Поиск не дал результатов</p>
    </v-container>
    <!-- скелетон -->
    <div v-if="ISLOAD">
      <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        width="100%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        width="100%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        width="100%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        ref="skeleton"
        type="card"
        class="mx-auto"
        width="100%"
      ></v-skeleton-loader>
    </div>

    <!-- /скелетон -->

    <!-- карточка -->
    <v-lazy
      transition="fade-transition"
      min-height="200"
      v-for="(vakansija, i) in VACANSII"
      :key="i"
      v-show="vakansija.isVisiblVak"
    >
      <v-container>

        <v-row no-gutters>
          <v-card
            width="100%"
            :class="`mx-auto ${PARTNER_CONFIG.theme_partner.cardVakans}`"
            color="#385F73"
          >
            <v-col
              cols="12"
              justify="space-between"
            >
              <!-- <v-card-title class="lighten">{{vakansija.headerVakans}}</v-card-title> -->
              <h3>{{ vakansija.headerVakans }}</h3>
              <br />
              <!--колонка картинки -->
              <v-row
                justify="space-between"
                no-gutters
              >

                <v-col cols="5">
                  <v-img
                    class="white--text align-end"
                    height="250"
                    max-width="400"
                    :src="vakansija.image"
                  >
                    <v-chip
                      class="ma-1"
                      :class="vakansija.isActual"
                      color="red"
                      text-color="white"
                      small
                    >
                      <v-icon>mdi-fire</v-icon>

                      Приезд {{ vakansija.priezd }}
                    </v-chip>

                    <v-chip
                      class="ma-1"
                      :class="vakansija.isBezviz"
                      color="green"
                      text-color="white"
                      small
                    >
                      <v-icon>mdi-hail</v-icon>

                      Безвиз
                    </v-chip>

                    <v-chip
                      class="ma-1"
                      :class="vakansija.isUa"
                      color="indigo"
                      text-color="white"
                      small
                    >
                      <v-icon>mdi-text-box-check-outline</v-icon>

                      UA котнтракт
                    </v-chip>
                  </v-img>
                </v-col>
                <!--/колонка картинки -->
                <v-col cols="7">
                  <!-- <v-card-title>{{vakansija.headerVakans}}</v-card-title> -->

                  <div>
                    <v-card-text class="category">
                      <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-google-maps</v-icon>
                      {{ vakansija.cyty }}
                    </v-card-text>
                  </div>

                  <div>
                    <v-card-text class="category">
                      <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-cash</v-icon>
                      {{ vakansija.salary }}
                    </v-card-text>
                  </div>
                  <div>
                    <v-card-text class="category">
                      <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-clock-time-four-outline</v-icon>
                      {{ vakansija.worchours }}
                    </v-card-text>
                  </div>

                  <div>
                    <v-card-text class="category">
                      <v-icon :class="PARTNER_CONFIG.theme_partner.iconVakans">mdi-human-male-female</v-icon>
                      {{ vakansija.gender }}
                    </v-card-text>
                  </div>

                  <div class="btn-category">
                    <!-- <v-btn @click="goToVakansija( vakansija.idVakans )">подробнее</v-btn> -->
                    <v-btn
                      :to="`Vakansija/${vakansija.idVakans}`"
                      :class="PARTNER_CONFIG.theme_partner.btnVakans"
                    >подробнее</v-btn>

                  </div>
                  <div>

                    <div class="text-right ">
                      <v-btn
                        v-if="!webShareApiSupported"
                        fab
                        dark
                        class="btnShareVib"
                      >
                        <a :href="`viber://forward?text=${vakansija.headerVakans} 
${urlSite}/Vakansija/${vakansija.idVakans}`">

                          <v-icon
                            large
                            dark
                          >mdi-share-variant</v-icon>

                        </a></v-btn>

                      <v-btn
                        v-if="webShareApiSupported"
                        fab
                        dark
                        @click="shareViaWebShare(vakansija)"
                        :class="PARTNER_CONFIG.theme_partner.btnShare"
                      >
                        <v-icon
                          large
                          dark
                        >mdi-share-variant</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <!-- <v-card-subtitle v-text="vakansija.kategory"></v-card-subtitle> -->

                  <!-- tyl -->
                </v-col>
              </v-row>
              <!--/колонка картинки -->
            </v-col>
            <v-row no-gutters> </v-row>
          </v-card>
        </v-row>

      </v-container>
    </v-lazy>

    <!-- /карточка -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      ex11: ["Актуальные вакансии"],
      items: [],
      sortedVakans: [],
      warning: false,
      search: { text: "" },
      emptysearch: false,
      isActive: false
    };
  },
  methods: {
    ...mapActions(["GET_VAKANS_FROM_API", "SEARCH_VAKANS"]),
    // goToVakansija(vacansId) {
    //   this.$router.push({ name: "Vakansija", params: { vakans: vacansId } });
    // },

    search_text() {
      if (this.search.text.length > 2) {
        this.SEARCH_VAKANS(this.search.text);

        // console.log(this.search.text.length);
      } else if (this.search.text.length == 0) {
        this.GET_VAKANS_FROM_API(this.ex11);
      }
      // let inside = this;
      // this.sortedVakans = this.VACANSII.filter(function(wonder) {
      //   if (
      //     wonder.headerVakans
      //       .toLowerCase()
      //       .indexOf(inside.search.text.toLowerCase()) != "-1"
      //   ) {
      //     return wonder;
      //   }
      // });
      // if (!this.sortedVakans.length && inside.search.text) {
      //   this.emptysearch = true;
      //   console.log(this.sortedVakans);
      // } else this.emptysearch = false;
    },

    changeWarning() {
      this.warning = true;
    },
    selectCategory() {
      this.warning = true;
      //console.log(this.warning);
      this.GET_VAKANS_FROM_API(this.ex11);
      setTimeout(() => (this.warning = false), 1000);
      //this.warning = false;
    },
    shareViaWebShare(vacansija) {
      let textShareVakans = `${vacansija.headerVakans}

      🚈 Место работы — ${vacansija.cyty}
      👧👨‍🚒 ${vacansija.gender}
      📄 ${vacansija.viza}
      💰 оплат ${vacansija.salary}
      🕒 часов ${vacansija.worchours}
      `;
      // let titleVak = titleVakans;

      let urlVakShare = "/Vakansija/" + vacansija.idVakans;

      if (navigator.share) {
        navigator.share({
          // title: vacansija.headerVakans,
          text: textShareVakans,
          url: urlVakShare
        });
      } else {
        console.log("ne share");
        window.location.href = "viber://forward?text=123";
      }
    }
  },

  computed: {
    ...mapGetters(["VACANSII", "ISLOAD", "PARTNER_CONFIG", "GET_EMPTY_SEARCH"]),

    // filterdVakans() {
    //   // console.log(this.ALL_VACANSII);
    //   //  console.log(this.sortedVakans.length);
    //   if (this.ex11.length) {
    //     return this.VACANSII;
    //   } else return this.ALL_VACANSII;
    // },
    webShareApiSupported() {
      return navigator.share;
    },
    urlSite() {
      return window.location.href;
    }
  },

  mounted() {
    this.GET_VAKANS_FROM_API(this.ex11);
    // console.log(this.VACANSII);
  }
};
</script>



<style lang="css" scoped>
.category {
  padding: 7px;
  /* margin: 0;
  color: brown; */
}

.btn-category {
  padding: 25px;
}

.categori-icon {
  color: brown;
  background-color: chartreuse;
  width: 50%;
}
.viza {
  display: none;
}
.neUa {
  display: none;
}
.neActual {
  display: none;
}

.btnShare {
  padding: 25px;
}
a {
  text-decoration: none;
}
</style>
